module.exports = __webpack_public_path__ + "img/head_phones.f3313e33.svg";